export enum OrderStatusEnum {
    ARRIVED_LOH = 'ARRIVED_LOH',
    VALIDATED_STRUCTURE = 'VALIDATED_STRUCTURE',
    VALIDATED_SERVICES_PRODUCTS_CLIENT = 'VALIDATED_SERVICES_PRODUCTS_CLIENT',
    SENT_OPTIFACTS = 'SENT_OPTIFACTS'
}